<template>
    <div :class="containerClass" class="w-full">
        <h2
            class="h-6 flex flex-row justify-center items-center text-xs overflow-hidden"
            v-text="conditionalCourseTitle"
        ></h2>
        <div class="flex flex-row flex-wrap">
            <div v-for="sco in course" :key="sco.sco_user_id" :class="scoWrapperClasses">
                <sco-card :sco="sco" :slug="slugify(sco.title)" :course="course"></sco-card>
            </div>
        </div>
        <div class="h-6"></div>
    </div>
</template>

<script>
import ScoCard from "@/components/courses/ScoCard.vue";
import slugify from "slugify";

export default {
    name: "CourseCard",
    components: {
        ScoCard
    },
    props: {
        course: {
            type: Array,
            required: true
        }
    },
    computed: {
        scoWrapperClasses() {
            switch (this.course.length) {
                case 1:
                    return "w-full";
                case 2:
                    return "w-full xl:w-1/2 xl:px-6";
                default:
                    return "w-full";
            }
        },
        containerClass() {
            if (this.course.length === 2) {
                return "bg-gray-200";
            }

            return "";
        },
        conditionalCourseTitle() {
            if (this.course.length > 1) {
                return this.course[0].course_title;
            }

            return " ";
        }
    },
    methods: {
        slugify(title) {
            return slugify(title, { lower: true, strict: true, locale: "en" });
        },
        cardWrapperClasses(course) {
            switch (course.length) {
                case 1:
                    return "w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 px-2 md:px-6 py-4";
                case 2:
                    return "w-full xl:w-1/2 px-2 md:px-6 py-4";
                default:
                    return "w-full";
            }
        }
    }
};
</script>
